import { PropertyList } from "@/components/host/properties/PropertyList";
import { PropertyListSkeleton } from "@/components/host/properties/PropertyListSkeleton";
import { HostPropertiesHeader } from "@/components/host/properties/HostPropertiesHeader";
import { useHostProperties } from "@/hooks/useHostProperties";
import { useToast } from "@/hooks/use-toast";

const HostPropertiesPage = () => {
  const { toast } = useToast();
  const { data: properties, isLoading, error } = useHostProperties();

  if (error) {
    toast({
      title: "Error loading properties",
      description: error.message,
      variant: "destructive",
    });
  }

  return (
    <div className="container mx-auto p-6">
      <HostPropertiesHeader />
      
      {isLoading ? (
        <PropertyListSkeleton />
      ) : (
        <PropertyList 
          properties={properties || []}
          showActions={true}
        />
      )}
    </div>
  );
};

export default HostPropertiesPage;